// extracted by mini-css-extract-plugin
module.exports = {"primaryButton":"AssistedInstallsTable-primaryButton-3epblC","tableWrapper":"AssistedInstallsTable-tableWrapper-1IaQR_"};